export default {
    //API_SERVER_URL: "https://data.testflowone.io"
    //API_SERVER_URL: "https://data.flowone.io"
    //API_SERVER_URL: "http://localhost:3007"
    API_SERVER_URL: "https://api.flowone.io"
}
